import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';
import classNames from './Icon.module.scss';

export const AiStarIcon = ({ width, height, style, grow }: SVGIconProps) => {
  return (
    <Center
      miw={width}
      mih={height}
      w={width}
      h={height}
      style={style}
      classNames={classNames}
      data-grow={grow}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 3C8.33346 3 8.62257 3.23075 8.6965 3.55589L9.09171 5.29389C9.2745 6.09779 9.90221 6.7255 10.7061 6.90829L12.4441 7.3035C12.7693 7.37743 13 7.66654 13 8C13 8.33346 12.7693 8.62257 12.4441 8.6965L10.7061 9.09171C9.90221 9.2745 9.2745 9.90221 9.09171 10.7061L8.6965 12.4441C8.62257 12.7693 8.33346 13 8 13C7.66654 13 7.37743 12.7693 7.3035 12.4441L6.90829 10.7061C6.7255 9.90221 6.09779 9.2745 5.29389 9.09171L3.55589 8.6965C3.23075 8.62257 3 8.33346 3 8C3 7.66654 3.23075 7.37743 3.55589 7.3035L5.29389 6.90829C6.09779 6.7255 6.7255 6.09779 6.90829 5.29389L7.3035 3.55589C7.37743 3.23075 7.66654 3 8 3Z"
          fill="url(#paint0_linear_11834_26519)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_11834_26519"
            x1="3.11494"
            y1="8"
            x2="12.7126"
            y2="8"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#732EF7" />
            <stop offset="1" stopColor="#4E84D9" />
          </linearGradient>
        </defs>
      </svg>
    </Center>
  );
};
